import React from 'react';
import { copyPhone } from '../utils/copyPhone';

const CopyPhoneText = ({ number, children, className = '', ...props }) => {
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            copyPhone(number);
        }
    };

    return (
        <span
            {...props}
            className={`copy-phone ${className}`.trim()}
            role="button"
            tabIndex={0}
            onClick={() => copyPhone(number)}
            onKeyDown={handleKeyDown}
            title="Скопіювати номер"
        >
            {children}
        </span>
    );
};

export default CopyPhoneText;
